
/* ═══════════════════════════════════════════════════════════════
   TL HOME - Scroll-triggered Animations
   ═══════════════════════════════════════════════════════════════ */

(function() {
  'use strict';

  // Intersection Observer for scroll animations
  const observerOptions = {
    root: null,
    rootMargin: '0px 0px -50px 0px',
    threshold: 0.1
  };

  const animateOnScroll = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate--slide-in');
        entry.target.setAttribute('data-animate', 'true');
      }
    });
  }, observerOptions);

  // Observe elements when DOM is ready
  document.addEventListener('DOMContentLoaded', () => {
    // Elements to animate on scroll
    const animateElements = document.querySelectorAll(
      '.scroll-trigger, ' +
      '.card-wrapper, ' +
      '.product-card-wrapper, ' +
      '.multicolumn-list__item, ' +
      '.collection-product-card, ' +
      '.rich-text, ' +
      '.image-with-text, ' +
      '.collapsible-content'
    );

    animateElements.forEach(el => {
      el.classList.add('scroll-trigger');
      animateOnScroll.observe(el);
    });

    // Header scroll effect
    const header = document.querySelector('.header-wrapper, header.header');
    if (header) {
      let lastScroll = 0;
      window.addEventListener('scroll', () => {
        const currentScroll = window.pageYOffset;
        if (currentScroll > 50) {
          header.classList.add('scrolled');
        } else {
          header.classList.remove('scrolled');
        }
        lastScroll = currentScroll;
      }, { passive: true });
    }

    // Add subtle parallax to hero sections
    const heroes = document.querySelectorAll('.banner, .image-banner');
    if (heroes.length && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      window.addEventListener('scroll', () => {
        const scrolled = window.pageYOffset;
        heroes.forEach(hero => {
          const rate = scrolled * 0.3;
          const img = hero.querySelector('img');
          if (img && scrolled < window.innerHeight) {
            img.style.transform = `translateY(${rate}px) scale(1.05)`;
          }
        });
      }, { passive: true });
    }

    // Cart icon bounce effect
    document.addEventListener('cart:item-added', () => {
      const cartBubble = document.querySelector('.cart-count-bubble');
      if (cartBubble) {
        cartBubble.classList.add('is-updated');
        setTimeout(() => cartBubble.classList.remove('is-updated'), 500);
      }
    });

    console.log('✨ TL Home luxury animations initialized');
  });
})();
